import gql from 'graphql-tag'

const removeCouponMutation = gql`
  mutation removeCoupon($couponId: ID!) {
    removeCoupon(input: { couponId: $couponId }) {
      coupon {
        id
      }
    }
  }
`

export default removeCouponMutation
